import { ReactElement } from 'react';
import { useTheme, TableRow, TableCell } from '@mui/material';

export function TableSectionHeaderRow({ label }: { label: string }): ReactElement {
  const theme = useTheme();

  return (
    <TableRow>
      <TableCell component="th" scope="row" sx={{ color: theme.palette.grey[500], height: '50px' }}>
        {label}
      </TableCell>
      <TableCell colSpan={3} />
    </TableRow>
  );
}
